export const FINANCE_HUB_PAYMENT_STATUS_LABELS = {
  unconfigured: "Не налаштовано",
  unpaid: "Не сплачено",
  partial: "Частково сплачено",
  paid: "Сплачено",
  overpaid: "Переплата",
  overdue: "Прострочено",
};

export const getFinanceHubPaymentStatusLabel = (status, { isOverdue } = {}) => {
  if (isOverdue) return FINANCE_HUB_PAYMENT_STATUS_LABELS.overdue;
  return FINANCE_HUB_PAYMENT_STATUS_LABELS[status] || status || "—";
};

export const FINANCE_HUB_INCOME_TYPE_LABELS = {
  "": "Не налаштовано",
  percent: "Відсоток",
  fixed: "Фіксована сума",
};

export const getFinanceHubIncomeTypeLabel = (incomeType) =>
  FINANCE_HUB_INCOME_TYPE_LABELS[incomeType] || incomeType || "—";

export const CANONICAL_CURRENCY_ORDER = ["UAH", "USD", "EUR"];

export function orderedCurrencyEntries(currencies) {
  const source = currencies && typeof currencies === "object" ? currencies : {};
  return CANONICAL_CURRENCY_ORDER
    .filter((code) => Object.prototype.hasOwnProperty.call(source, code))
    .map((code) => [code, source[code]]);
}
